import { TranscriptType } from '../constants';

export const ROLE_TRANSCRIPT_TYPE_MAP: Record<string, TranscriptType> = {
  'ITP HS Processor': TranscriptType.HighSchool,
  'ITP Processor': TranscriptType.College
};

export interface ProcessorRoleInfo {
  singleType: TranscriptType | null;
  isPowerProcessor: boolean;
}

/**
 * Gets user role info to determine what default queue and labels will load.
 * @param roles - The roles from the user's auth state
 */
export function getProcessorRoleInfo(roles: Array<{ key: string }> = []): ProcessorRoleInfo {
  const matchedTypes = new Set(
    roles.map(role => ROLE_TRANSCRIPT_TYPE_MAP[role.key]).filter(type => type !== undefined)
  );

  return {
    singleType: matchedTypes.size === 1 ? [...matchedTypes][0] : null,
    isPowerProcessor: matchedTypes.size > 1
  };
}
